import * as ActionTypes from '../ActionTypes';
const Order = (
  state = { isLoading: true, errorMess: null, Order: [] },
  action
) => {
  switch (action.type) {
    case ActionTypes.ORDERS_ADD:
      console.log(
        action.payload,
        'action.payload ----------Order ',
        state.Order
      );
      return {
        ...state,
        isLoading: false,
        errorMess: '',
        Order: state.Order.concat(...action.payload),
      };

    case ActionTypes.ORDERS_LOADING:
      console.log(action.payload);
      return {
        ...state,
        isLoading: true,
        errorMess: '',
        Order: [],
      };

    case ActionTypes.ORDERS_ERROR:
      return {
        ...state,
        isLoading: false,
        errorMess: action.payload,
      };
    default:
      return { ...state };
  }
};

export default Order;
